import React from "react";

interface HageBreadcrumbsProps {
  items: [string, string?][];
}

export default function HageBreadcrumbs({ items = [] }: HageBreadcrumbsProps) {
  if (!items.length) return null;

  return (
    <nav className="hage-breadcrumbs" aria-label="Brødsmulesti">
      <div className="container">
        <ol>
          {items.map(([label, url], idx) => (
            <li key={idx}>
              {url ? (
                <a href={url}>{label}</a>
              ) : (
                <span aria-current="page">{label}</span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}
